<template>
  <v-app>
    <SkipLink />
    <v-main id="main-content" tabindex="-1">
      <v-container>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import SkipLink from "@/components/Common/SkipLink.vue";

export default {
  components: {
    SkipLink,
  },
  created() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss" scoped></style>
